// Webpack Imports
import * as bootstrap from 'bootstrap';

const $dropdown = $("#menu-hauptmenue > .dropdown");
const $dropdownToggle = $("#menu-hauptmenue > .dropdown-toggle");
const $dropdownMenu = $(".dropdown-menu");
const showClass = "show";


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
	
	
		
	$(window).on("DOMContentLoaded resize", function() {
	  //if ( this.matchMedia("(min-width: 768px)").matches) {
	  if ( this.matchMedia('(hover: hover) and (pointer: fine)').matches) {
		$dropdown.hover(
		  function() {
			const $this = $(this);
			$this.addClass(showClass);
			$this.find($dropdownToggle).attr("aria-expanded", "true");
			//$this.find($dropdownMenu).addClass(showClass);
			$this.children($dropdownMenu).addClass(showClass);
		  },
		  function() {
			const $this = $(this);
			$this.removeClass(showClass);
			$this.find($dropdownToggle).attr("aria-expanded", "false");
			$this.children($dropdownMenu).removeClass(showClass);
		  }
		);
	  } else {
		$dropdown.off("mouseenter mouseleave");
	  }
	});	
/*	
	$(".menu-item-has-children li.menu-item-has-children > a").click(function(e) {
		
		//if ( e.currentTarget.offsetWidth - e.offsetX < 50) { //clicked on pseudo element
		if ( e.offsetX <= 30) { //clicked on pseudo element
			e.preventDefault();
			$(e.currentTarget).next("ul.dropdown-menu").toggleClass("show-submenu");
			$(e.currentTarget).toggleClass("show-submenu");
		}	
	});
*/	
	$(".menu-item-has-children > a .caret").click(function(e) {
		
		//if ( e.currentTarget.offsetWidth - e.offsetX < 50) { //clicked on pseudo element
		// if ( e.offsetX <= 30) { //clicked on pseudo element
			e.preventDefault();
			$(e.currentTarget).closest("a").next("ul.dropdown-menu").toggleClass("show");
			$(e.currentTarget).toggleClass("show");
		// }	
	});
	
} )();